import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, StackView, Typography, Button, Link } from '@telus-uds/components-web';
import { useLanguage } from '../../hooks/useLanguage';

const t = {
  hangInThere: { en: 'Hang in there', fr: 'Accroche-toi' },
  supportMessageFirstPart: {
    en: "We couldn't find the page you're looking for. For help, reach out to the",
    fr: "Nous n'avons pas trouvé la page demandée. Pour obtenir de l'aide, contactez le canal",
  },
  supportMessageSecondPart: {
    en: 'Slack channel.',
    fr: 'sur Slack.',
  },
  returnToPreviousPage: {
    en: 'Return to previous page',
    fr: 'Retour à la page précédente',
  },
} as const;

export const ErrorMessagePage = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  return (
    <Box horizontal={7} vertical={9}>
      <StackView space={5} tokens={{ alignItems: 'flex-start' }}>
        <Typography variant={{ size: 'display1' }}>{t.hangInThere[language]}</Typography>
        <Typography block variant={{ size: 'h4' }}>
          {t.supportMessageFirstPart[language]}{' '}
          <Link href="https://telusdigital.slack.com/archives/C03CN3X3FBJ" target="_blank">
            #g-simplifyhub
          </Link>{' '}
          {t.supportMessageSecondPart[language]}
        </Typography>
        <Button variant={{ priority: 'high' }} onPress={() => navigate(-1)}>
          {t.returnToPreviousPage[language]}
        </Button>
      </StackView>
    </Box>
  );
};
